// extracted by mini-css-extract-plugin
module.exports = {"Container":"MethodologyView-module--Container--FChaY","Title":"MethodologyView-module--Title--314Jz","SubTitle":"MethodologyView-module--SubTitle--2xV5_"};